import { __assign, __generator, __spreadArray } from "tslib";
import { call, all, takeLatest, put, select, takeEvery, } from 'redux-saga/effects';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import { editDeviation, deleteDeviation, deleteDeviationSuccess, fetchDeviation, } from './actionCreators';
import { actions as modalActions } from '../../Modals';
import { ModalType } from '../../Modals/redux/types';
import { getDeviationType, getDeviationUrl, } from '../../DeviationViews/_helpers';
import { DeviationTypes, DeviationResourceType } from '../../types/deviation';
import { normalize } from '../normalizr';
import { deviationExtendedSchema, deviationSchema, getCompositeId, } from '../normalizr/schemas/deviation';
import { putEntities } from '../entities/actions';
import { request } from '../../xhr';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { getDeviationById, getDeviationEditUrl, getIsCurrentUserAuthorOf, getNormalizedDeviationById, } from './selectors';
import { Url, URLS } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { publishCommentSuccess } from '../../CommentBox/actionCreators';
import { getDeviationTypeForCommentableType } from '../../DeviationPage/redux/helpers';
import { getDataEntityById } from '../entities/selectors';
import { awardBadgeSuccess } from '../../coreBadge/redux/actionCreators';
var logger = ddt.createLogger('deviationsaga');
function fakeResponse(options) {
    logger.log('faking the response!');
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        if (options && options.url === '/deviation/fetch') {
            // eslint-disable-next-line
            var deviationsByType = require('@wix/da-sample-data').deviationsByType;
            return __assign(__assign({}, deviationsByType.image[0]), { deviationId: options.params.deviationid });
        }
        return {
            success: true,
        };
    }
}
function doPostPapiRequest(endpoint, data) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                logger.log("calling " + endpoint + " endpoint");
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: endpoint,
                        data: data,
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function doGetPapiRequest(endpoint, params) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                logger.log("calling " + endpoint + " endpoint");
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: endpoint,
                        params: params,
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function deleteDeviationSaga(_a) {
    var isLoggedIn, isOwner, canDelete, endpoint, params, deviationType, deviationId, userid, result, deletedDeviation, entities;
    var _b, _c;
    var _d = _a.payload, deviation = _d.deviation, shouldRedirect = _d.shouldRedirect;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!deviation) {
                    logger.error('Tried to delete an invalid deviation', deviation);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _e.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.DELETE_DEVIATION }))];
            case 2:
                _e.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getIsCurrentUserAuthorOf, deviation)];
            case 4:
                isOwner = _e.sent();
                canDelete = (_c = (_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.canUserDelete) !== null && _c !== void 0 ? _c : isOwner;
                if (!canDelete) {
                    logger.log('Cannot delete deviation', deviation, isOwner);
                    return [2 /*return*/];
                }
                deviationType = getDeviationType(deviation);
                deviationId = deviation.deviationId;
                userid = deviation.author && deviation.author.userId;
                switch (deviationType) {
                    case DeviationTypes.STATUS:
                        endpoint = '/status/delete';
                        params = {
                            statusid: deviationId,
                            userid: userid,
                        };
                        break;
                    case DeviationTypes.POLL:
                        endpoint = '/poll/delete';
                        params = {
                            pollid: deviationId,
                            userid: userid,
                        };
                        break;
                    case DeviationTypes.COMMISSION:
                        endpoint = '/commission/delete';
                        params = {
                            commissionid: deviationId,
                        };
                        break;
                    default:
                        endpoint = '/deviation/delete';
                        params = {
                            deviationid: deviationId,
                        };
                }
                return [4 /*yield*/, call(doPostPapiRequest, endpoint, params)];
            case 5:
                result = _e.sent();
                if (!(result && result.success)) return [3 /*break*/, 7];
                if (shouldRedirect) {
                    window.location.assign(deviation.author ? Url.userLink(deviation.author.username) : URLS.ROOT);
                    return [2 /*return*/];
                }
                deletedDeviation = __assign(__assign({}, deviation), { isDeleted: true });
                entities = normalize(deletedDeviation, deviationSchema).entities;
                return [4 /*yield*/, all([
                        put(putEntities({ entities: entities })),
                        put(deleteDeviationSuccess({ deviation: deletedDeviation })),
                    ])];
            case 6:
                _e.sent();
                _e.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
function getDeviationTypeNameFromTypeId(typeId) {
    switch (typeId) {
        case DeviationResourceType.JOURNAL:
            return 'journal';
        case DeviationResourceType.COMMISSION:
            return 'commission';
        case DeviationResourceType.POLL:
            return 'poll';
        case DeviationResourceType.STATUS:
            return 'status-update';
        case DeviationResourceType.TIER:
            // TODO member_subscriptions clean up any when backend supports tiers for related content
            return 'tier';
        default:
            return 'art';
    }
}
function getExtendedDeviation(deviation, forceFetch) {
    var isExpanded, deviationType, result, _a, deviationIdPropName, params, entities;
    var _b;
    if (forceFetch === void 0) { forceFetch = false; }
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                isExpanded = !!get(deviation, 'textContent.html.markup');
                if (!forceFetch && isExpanded) {
                    logger.log('Deviation already expanded', deviation);
                    return [2 /*return*/, { deviation: deviation }];
                }
                deviationType = getDeviationType(deviation);
                _a = deviationType;
                switch (_a) {
                    case DeviationTypes.STATUS: return [3 /*break*/, 1];
                    case DeviationTypes.LITERATURE: return [3 /*break*/, 1];
                    case DeviationTypes.JOURNAL: return [3 /*break*/, 1];
                    case DeviationTypes.COMMISSION: return [3 /*break*/, 1];
                    case DeviationTypes.POLL: return [3 /*break*/, 1];
                    case DeviationTypes.TIER: return [3 /*break*/, 3];
                }
                return [3 /*break*/, 5];
            case 1:
                deviationIdPropName = [DeviationTypes.JOURNAL].includes(deviationType)
                    ? 'deviationid'
                    : deviationType + "id";
                logger.log('Deviation PropName', deviationIdPropName, deviation);
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: "/" + deviationType,
                        params: (_b = {},
                            _b[deviationIdPropName] = deviation.deviationId,
                            _b.username = deviation.author.username,
                            _b.expand = 'deviation.fulltext',
                            _b),
                    })];
            case 2:
                result = _c.sent();
                return [3 /*break*/, 6];
            case 3:
                params = {
                    deviationid: deviation.deviationId,
                    username: deviation.author && deviation.author.username,
                    type: getDeviationTypeNameFromTypeId(deviation.typeId),
                    include_session: false,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/extended_fetch',
                        params: params,
                    })];
            case 4:
                result = _c.sent();
                return [3 /*break*/, 6];
            case 5: return [2 /*return*/, deviation];
            case 6:
                logger.log('Extended deviation', result.deviation);
                entities = normalize(result.deviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 7:
                _c.sent();
                return [2 /*return*/, result];
        }
    });
}
/**
 * Listen to editDeviation actions and fire the
 * correct edit deviation action depending on the deviation type.
 */
function editDeviationSaga(_a) {
    var isLoggedIn, isOwner, canUserEdit, editUrl, isTextEditable, legacyTextEditUrl, extended, deviationType, needExtendedInfo, expandedDeviationResult, params, _b;
    var _c = _a.payload, deviation = _c.deviation, fromDeviationPage = _c.fromDeviationPage;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _d.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.EDIT_DEVIATION }))];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getIsCurrentUserAuthorOf, deviation)];
            case 4:
                isOwner = _d.sent();
                canUserEdit = get(deviation, 'extended.canUserEdit', isOwner);
                if (!canUserEdit) {
                    logger.log('Attempted to edit a deviation that is not owned by you.', deviation);
                    return [2 /*return*/];
                }
                editUrl = getDeviationEditUrl(deviation);
                if (editUrl) {
                    return [2 /*return*/, window.location.assign(editUrl)];
                }
                isTextEditable = deviation.isTextEditable, legacyTextEditUrl = deviation.legacyTextEditUrl, extended = deviation.extended;
                deviationType = getDeviationType(deviation);
                needExtendedInfo = isTextEditable || [DeviationTypes.TIER].includes(deviationType);
                if (!needExtendedInfo) return [3 /*break*/, 19];
                return [4 /*yield*/, call(getExtendedDeviation, deviation, !extended)];
            case 5:
                expandedDeviationResult = _d.sent();
                params = {
                    deviation: expandedDeviationResult.deviation,
                };
                _b = deviationType;
                switch (_b) {
                    case DeviationTypes.STATUS: return [3 /*break*/, 6];
                    case DeviationTypes.JOURNAL: return [3 /*break*/, 8];
                    case DeviationTypes.LITERATURE: return [3 /*break*/, 10];
                    case DeviationTypes.COMMISSION: return [3 /*break*/, 12];
                    case DeviationTypes.POLL: return [3 /*break*/, 14];
                    case DeviationTypes.TIER: return [3 /*break*/, 16];
                }
                return [3 /*break*/, 18];
            case 6: return [4 /*yield*/, put(modalActions.pushModal(ModalType.STATUS_UPDATE, {
                    wrapInModal: false,
                    params: params,
                }))];
            case 7:
                _d.sent();
                return [3 /*break*/, 18];
            case 8:
                params.isFeatured =
                    expandedDeviationResult.featured ||
                        get(params, 'deviation.extended.isFeaturedJournal', false);
                /** TODO: Uncomment when we know what the actual mature field on journals is
                params.isMature =
                  expandedDeviationResult.mature ||
                  get(params, 'deviation.extended.isMatureJournal', false);
                */
                return [4 /*yield*/, all([
                        put(modalActions.initModal(ModalType.JOURNAL, {
                            params: params,
                        })),
                        put(modalActions.pushModal(ModalType.JOURNAL, {
                            wrapInModal: false,
                            params: params,
                        })),
                    ])];
            case 9:
                /** TODO: Uncomment when we know what the actual mature field on journals is
                params.isMature =
                  expandedDeviationResult.mature ||
                  get(params, 'deviation.extended.isMatureJournal', false);
                */
                _d.sent();
                return [3 /*break*/, 18];
            case 10: return [4 /*yield*/, put(modalActions.pushModal(ModalType.LITERATURE, {
                    wrapInModal: false,
                    params: params,
                }))];
            case 11:
                _d.sent();
                return [3 /*break*/, 18];
            case 12: return [4 /*yield*/, put(modalActions.pushModal(ModalType.COMMISSION, {
                    wrapInModal: false,
                    params: __assign(__assign({}, params), { redirectOnSubmit: fromDeviationPage }),
                }))];
            case 13:
                _d.sent();
                return [3 /*break*/, 18];
            case 14: return [4 /*yield*/, put(modalActions.pushModal(ModalType.POLL_EDIT, {
                    wrapInModal: false,
                    params: params,
                }))];
            case 15:
                _d.sent();
                return [3 /*break*/, 18];
            case 16: return [4 /*yield*/, put(modalActions.pushModal(ModalType.TIER_EDIT, {
                    wrapInModal: false,
                    params: params,
                }))];
            case 17:
                _d.sent();
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
            case 19:
                if (legacyTextEditUrl) {
                    return [2 /*return*/, window.location.assign(legacyTextEditUrl)];
                }
                window.location.assign(getDeviationUrl(deviation));
                return [2 /*return*/];
        }
    });
}
function fetchDeviationSaga(_a) {
    var result, entities, deviation;
    var _b = _a.payload, deviationid = _b.deviationid, username = _b.username, type = _b.type, onSuccess = _b.onSuccess;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(doGetPapiRequest, '/deviation/fetch', {
                    deviationid: deviationid,
                    username: username,
                    type: type,
                })];
            case 1:
                result = _c.sent();
                if (!(result && !result.error)) return [3 /*break*/, 5];
                entities = normalize(result, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _c.sent();
                if (!onSuccess) return [3 /*break*/, 5];
                return [4 /*yield*/, select(getDeviationById, deviationid)];
            case 3:
                deviation = _c.sent();
                return [4 /*yield*/, call(onSuccess, deviation)];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
// increment comment count on deviations when new comments are posted
function handlePublishComment(_a) {
    var deviationTypeId, entityId, deviation, updatedDeviation;
    var _b, _c;
    var _d, _e;
    var _f = _a.payload, isEdit = _f.isEdit, comment = _f.comment;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                if (isEdit || !comment) {
                    return [2 /*return*/];
                }
                deviationTypeId = getDeviationTypeForCommentableType(comment.typeId);
                entityId = getCompositeId(deviationTypeId, comment.itemId);
                return [4 /*yield*/, select(getNormalizedDeviationById, entityId)];
            case 1:
                deviation = _g.sent();
                if (!deviation) {
                    return [2 /*return*/];
                }
                updatedDeviation = __assign(__assign({}, deviation), { stats: __assign(__assign({ favourites: 0 }, deviation.stats), { comments: ((_e = (_d = deviation.stats) === null || _d === void 0 ? void 0 : _d.comments) !== null && _e !== void 0 ? _e : 0) + 1 }), hasCommentedOn: true });
                return [4 /*yield*/, put(putEntities({
                        entities: (_b = {},
                            _b[deviationSchema.key] = (_c = {},
                                _c[entityId] = updatedDeviation,
                                _c),
                            _b),
                    }))];
            case 2:
                _g.sent();
                return [2 /*return*/];
        }
    });
}
function handleAwardBadge(action) {
    var _a, badge, recipient, deviation, extendedData, existingAwardedBadges, updatedExtData, updatedDeviation, deviationNormalized;
    var _b, _c;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = action.payload, badge = _a.badge, recipient = _a.recipient;
                if (!(recipient.typeId in DeviationResourceType)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getDataEntityById, deviationSchema, recipient.itemId)];
            case 1:
                deviation = _e.sent();
                return [4 /*yield*/, select(getDataEntityById, deviationExtendedSchema, recipient.itemId)];
            case 2:
                extendedData = _e.sent();
                if (!deviation || !extendedData) {
                    return [2 /*return*/];
                }
                existingAwardedBadges = (_d = extendedData.awardedBadges) !== null && _d !== void 0 ? _d : [];
                updatedExtData = __assign(__assign({}, extendedData), { awardedBadges: uniqBy(__spreadArray([badge], existingAwardedBadges), 'name') });
                updatedDeviation = __assign({}, deviation);
                deviationNormalized = normalize(updatedDeviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({
                        entities: __assign(__assign({}, deviationNormalized), (_b = {}, _b[deviationExtendedSchema.key] = (_c = {},
                            _c[recipient.itemId] = updatedExtData,
                            _c), _b)),
                    }))];
            case 3:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(editDeviation, editDeviationSaga),
                    takeLatest(deleteDeviation, deleteDeviationSaga),
                    takeLatest(fetchDeviation, fetchDeviationSaga),
                    takeEvery(publishCommentSuccess, handlePublishComment),
                    takeEvery(awardBadgeSuccess, handleAwardBadge),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map